<template>
  <v-item-group
    v-if="hasItems"
    v-model="selected"
    class="d-flex flex-column"
    :multiple="multiple"
  >
    <expansion-panel
      v-for="(item, i) in items"
      :key="getItemKey(item, i)"
      class="mb-3"
      :value="isPanelOpen(item)"
      :item-value="getItemValue(item)"
      :class="panelClass"
      :show-collapse-button="showCollapseButton"
      :keep-activator="keepActivator"
    >
      <template #activator="{ isActive }">
        <slot v-bind="{ item, isActive }" name="activator"></slot>
      </template>
      <template #default="{ toggle, isActive }">
        <slot
          v-bind="{ item, toggle, isActive }"
          name="content"
        ></slot>
      </template>
    </expansion-panel>
  </v-item-group>
</template>

<script>
import ExpansionPanel from './ExpansionPanel';

export default {
  name: 'ExpansionPanels',
  components: { ExpansionPanel },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    valueProp: {
      type: String,
      default: null,
    },
    panelClass: {
      type: String,
      default: null,
    },
    showCollapseButton: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    keepActivator: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selected: {
      set: function (value) {
        if (!this.multiple) {
          value = [value];
        }
        const selectedItems = this.valueProp
          ? value
              .map((v) => this.getItemFromValue(v))
              .filter((v) => !!v)
          : value;
        this.$emit('input', selectedItems);
      },
      get: function () {
        let value = this.valueProp
          ? this.value
              .filter((item) => !!item)
              .map((item) => this.getItemValue(item))
          : this.value;
        if (!this.multiple) {
          value = value[0];
        }
        return value;
      },
    },
    hasItems() {
      return this.items && this.items.length > 0;
    },
  },
  methods: {
    isPanelOpen(item) {
      const valueProp = this.valueProp;
      if (valueProp) {
        return this.value.some(
          (x) => x[valueProp] === item[valueProp]
        );
      }
      return this.value.includes(item);
    },
    getItemKey(item, index) {
      return this.valueProp ? item[this.valueProp] : index;
    },
    getItemValue(item) {
      return this.valueProp ? item[this.valueProp] : item;
    },
    getItemFromValue(value) {
      return this.valueProp
        ? this.items.find((i) => i[this.valueProp] === value)
        : value;
    },
  },
};
</script>
